import React from "react";
import Mcash from "../../assets/assets/mcash-main.svg";
import Nip from "../../assets/assets/nip-main.svg";
import Pos from "../../assets/assets/pos-main.svg";
import Central from "../../assets/assets/central-main.svg";
import Ebills from "../../assets/assets/ebills-main.svg";
import Lounge from "../../assets/assets/lounge.svg";
import Simswap from "../../assets/assets/sim-swap.svg";
import Biometric from "../../assets/assets/biometric.svg";
import Icad from "../../assets/assets/icad.svg";
import Nibsspay from "../../assets/assets/nibsspay.svg";
import Cmms from "../../assets/assets/cmms.svg";
import Encrypt from "../../assets/assets/encryption.svg";
import Bvn from "../../assets/assets/bvn-validation.svg";
import Epcoss from "../../assets/assets/epcoss.svg";

const Products = [
  {
    name: "POS",
    logo: Pos,
  },
  {
    name: "NIP",
    logo: Nip,
  },
  {
    name: "MCASH",
    logo: Mcash,
  },
  {
    name: "EBILLS",
    logo: Ebills,
  },
  {
    name: "CENTRAL PAY",
    logo: Central,
  },
  {
    name: "BIOMETRIC",
    logo: Biometric,
  },
  {
    name: "EPCOSS",
    logo: Epcoss,
  },
  {
    name: "CMMS",
    logo: Cmms,
  },
  {
    name: "ICAD",
    logo: Icad,
  },
  {
    name: "SIMSWAP",
    logo: Simswap,
  },
  {
    name: "NIBSSPAY",
    logo: Nibsspay,
  },
  {
    name: "ENCRYPT",
    logo: Encrypt,
  },
  {
    name: "BVN",
    logo: Bvn,
  },
  {
    name: "LOUNGE",
    logo: Lounge,
  },
];

const SideMenu = () => {
  return (
    <div className="nip-sidemenu">
      <h1>Other Products</h1>
      <p>Get direct access to all products Sandbox</p>

      <div className="nip-sidemenu-products">
        {Products.map((product, index) => (
          <div className="nip-sidemenu-products-each" key={index}>
            <div className="nip-sidemenu-products-each-image">
              <div className="nip-sidemenu-products-each-image-holder">
                <img src={product.logo} alt="product logo" />
              </div>
            </div>
            <div className="nip-sidemenu-products-each-name">
              {product.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SideMenu;
